<template>
  <div class="featured-article">
    <div class="featured-article__inner">
      <div
        v-if="fields && fields.image && fields.image.value && fields.image.value.src"
        class="featured-article__image"
        :style="{ 'background-image': 'url(' + fields.image.value.src + ')' }"
      ></div>
      <div v-else class="featured-article__image"></div>
      <div class="featured-article__content">
        <sc-text
          tag="h2"
          v-if="fields && fields.heading"
          :field="fields.heading"
          class="featured-article__title"
        />
        <sc-text
          tag="p"
          v-if="fields && fields.content"
          :field="fields.content"
          class="featured-article__intro"
        />
        <sc-link
          v-if="fields && fields.cta"
          :field="fields.cta"
          class="c-cta--primary"
          :class="fields.cta.value.class"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Landing-Featured',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-article {
  @include padding-x-thin;

  &__inner {
    &:deep() {
      display: flex;
      position: relative;
      @include add-Shadow;
      max-width: $main-max-width;
      @include margin-x(0);
      @include margin-y(auto, 2rem);
      margin-top: -30rem;

      @include tablet-down {
        flex-wrap: wrap;
      }

      @include tablet-up {
        @include margin-x(auto);
        margin-top: -16rem;
      }

      .featured-article__image {
        min-height: 21.6rem;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        min-width: 30rem;
        width: 100%;

        @include tablet-up {
          display: flex;
          width: 50%;
        }

        @include large-desktop-up {
          background-size: cover;
        }
      }

      .featured-article__content {
        padding: 4.5rem 2rem 0 2rem;
        position: relative;

        @include tablet-up {
          width: 50%;
          padding: 5rem 3rem 2rem 3rem;
        }

        &:before {
          content: 'Featured';
          @include bug;
        }

        .featured-article__title {
          @include font-styles('Arial', 2.5rem, 200, normal, normal, 0, $dark-blue);
          margin-bottom: 1rem;

          @include desktop-up {
            font-size: 2.8rem;
            line-height: 3.5rem;
          }
        }

        .featured-article__intro {
          @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $dark-blue);
          margin-bottom: 2rem;

          @include desktop-up {
            font-size: 2rem;
            line-height: 2.6rem;
          }
        }

        .featured-article__link {
          display: block;
          @include font-styles('Arial', 1.4rem, 600, normal, 2rem, 0, $blue);
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
